import { type MouseEvent, type ReactNode } from 'react'

export function FeishuOauthLink({ href, className, children, onNavigate }: {
  href?: string
  className?: string
  children: ReactNode
  onNavigate?: () => void
}) {
  function prepareNavigation(event: MouseEvent<HTMLAnchorElement>) {
    if (!href) {
      event.preventDefault()
      return
    }
    if (event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      onNavigate?.()
    }
  }

  // Keep this as a native same-frame link: Feishu WebView may block scripted or top-frame navigation.
  return <a className={className} href={href} aria-disabled={href ? undefined : true} onClick={prepareNavigation}>{children}</a>
}
